export const titleCase = (sourceString: string): string =>
  sourceString
    .toLowerCase()
    .split(' ')
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');

/**
 *
 * @param sourceString
 * @returns comma space source string if the string isn't blank
 */
export const validStringFromArray = (sourceString: string): string =>
  sourceString?.length > 0 ? ', ' + sourceString : '';

export const camelToTitleCase = (sourceString: string): string =>
  titleCase(sourceString.replace(/([A-Z0-9])/g, ' $1'));
